import CryptoJS from 'crypto-js';
import UserService from "./user.service";
import router from '../router'

// class with functions for token api calls
class TokenService {

//get local refresh token
  getLocalRefreshToken() {
    const refreshToken = JSON.parse(sessionStorage.getItem("rpt"));
    return refreshToken;
  }

  //get local access token
  getLocalAccessToken() {
    const token = JSON.parse(sessionStorage.getItem("act"));
    return token;
  }


  //update token in sessionstorage 
  updateLocalAccessToken(token) {
    let emsUser = {};
    emsUser.id = token.id;
    emsUser.username = token.username;
    emsUser.username = token.username;
    emsUser.companyName = token.companyName;
    emsUser.role = token.role;
    sessionStorage.setItem("act", JSON.stringify(token.access_token));
    sessionStorage.setItem("rpt", JSON.stringify(token.refresh_token));



    const crypt = CryptoJS.AES.encrypt(JSON.stringify(emsUser), 'titanic is strong in this one').toString();
    sessionStorage.setItem("user", JSON.stringify(crypt));
    this.getRole(emsUser, 2);
  }

  //get user from sessiostorage
  getUser() {
    const crypt = JSON.parse(sessionStorage.getItem("user"));
    const decryptedText = CryptoJS.AES.decrypt(crypt, 'titanic is strong in this one').toString(CryptoJS.enc.Utf8)
    return JSON.parse(decryptedText)
  }

  //set user in sessionstorage
  setUser(user) {
    // console.log("user2" + JSON.stringify(user))
    let emsUser = {};
    emsUser.id = user.id;
    emsUser.username = user.username;
    emsUser.company = user.company;
    emsUser.role = 0;
    emsUser.companyName = user.companyName;
    sessionStorage.setItem("act", JSON.stringify(user.access_token));
    sessionStorage.setItem("rpt", JSON.stringify(user.refresh_token));

    const crypt = CryptoJS.AES.encrypt(JSON.stringify(emsUser), 'titanic is strong in this one').toString();
    sessionStorage.setItem("user", JSON.stringify(crypt));


    this.getRole(emsUser, 1);


  }


  //get users role  
  getRole(emsUser, page) {

    UserService.getUser(emsUser.id).then(
      response => {
        emsUser.role = response.data.RoleId;
        const crypt = CryptoJS.AES.encrypt(JSON.stringify(emsUser), 'titanic is strong in this one').toString();
        sessionStorage.setItem("user", JSON.stringify(crypt));
        if (page == 1) {
          router.push("/monitordashboard")
        }
      });
  }

  //remove user from sessionstorage
  removeUser() {
    sessionStorage.removeItem("user");
  }
}

export default new TokenService();
